export const ICONS: readonly string[] = [
  'sfp',
  'rp',
  'dms',
  'quiver',
  'mosaic',
  'summit',
  'space',
  'tools',
  'rate',
  'settings',
  'air-ballon',
  'air-conditioning',
  'bag1',
  'bag2',
  'bath',
  'bed',
  'bottle1',
  'bottle2',
  'bowl',
  'box3',
  'bread',
  'briefcase',
  'bucket',
  'bulb1',
  'bulb2',
  'burger',
  'cake',
  'carrot',
  'cart2',
  'cart3',
  'cassete',
  'chair1',
  'chicken',
  'cloud-sun',
  'cloud1',
  'coffee1',
  'coffee2',
  'compass',
  'cooking-pot',
  'crown',
  'curtains',
  'deer',
  'diagnostics',
  'dinner',
  'fire',
  'fish',
  'french-bread',
  'frying-pan',
  'glass-martini',
  'globe',
  'ice-cream1',
  'ice-cream2',
  'kettle',
  'lamp1',
  'lamp2',
  'mailbox',
  'mc',
  'mirror',
  'miso-soup',
  'money',
  'moon',
  'movie-lane1',
  'orange',
  'outlet',
  'pantone',
  'radio',
  'rain1',
  'rain2',
  'rainbow',
  'roller',
  'rolling-pin',
  'saucepan',
  'shield-thunder',
  'snow',
  'storm',
  'sun-glasses',
  'sun',
  'suset1',
  'thunder-move',
  'thunder',
  'tie',
  'two-bottles',
  'umbrella',
  'vynil',
  'water-mixer',
  'weight2',
  'wind',
  'wine',
  'wood1',
  'wood2',
]
